// История поисковых запросов пользователя — localStorage браузера.
// Максимум MAX_ITEMS последних запросов, дедуп без учёта регистра
// (повторный запрос переносится наверх). Инлайн-шаблоны поиска
// (vue:search_complete) работают с глобалом window.searchHistory.

const STORAGE_KEY = 'searchHistory';
const MAX_ITEMS = 10;
const MIN_QUERY_LENGTH = 3;

const isBrowserStorageAvailable = () => {
  try {
    return typeof window !== 'undefined' && !!window.localStorage;
  } catch (e) {
    return false;
  }
};

export const getHistory = () => {
  if (!isBrowserStorageAvailable()) {
    return [];
  }

  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    const list = raw ? JSON.parse(raw) : [];

    return Array.isArray(list) ? list.filter((item) => typeof item === 'string') : [];
  } catch (e) {
    return [];
  }
};

const saveHistory = (list) => {
  if (!isBrowserStorageAvailable()) {
    return;
  }

  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list.slice(0, MAX_ITEMS)));
  } catch (e) {
    // приватный режим/переполнение квоты — молча живём без истории
  }
};

export const pushHistory = (query) => {
  const value = String(query || '').trim();

  if (value.length < MIN_QUERY_LENGTH) {
    return getHistory();
  }

  const lower = value.toLowerCase();
  // дедуп без учёта регистра: убираем прежний вхождение, новое — наверх
  const list = getHistory().filter((item) => item.toLowerCase() !== lower);
  list.unshift(value);

  const capped = list.slice(0, MAX_ITEMS);
  saveHistory(capped);

  return capped;
};

export const removeHistory = (query) => {
  const lower = String(query || '').trim().toLowerCase();
  const list = getHistory().filter((item) => item.toLowerCase() !== lower);

  saveHistory(list);

  return list;
};

export const clearHistory = () => {
  saveHistory([]);

  return [];
};
